import * as React from 'react';

export function useIsMac() {
    return React.useMemo(() => navigator.platform.toLowerCase().startsWith('mac'), []);
}
